import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../../widgets/loader";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import BWTSCargoMachin from "../../components/CargoMachinCom/BWTSCargoMachin";
import { CargoCran } from "../../components/CargoMachinCom/CargoCran";

export const CargoCraneList = ({ id }) => {
  const { eng_log_basic_id: paramId } = useParams();
  const eng_log_basic_id = id || paramId;
  const [loader, set_loader] = useState(false);
  const [CRAN_Data, set_CRAN_Data] = useState([]);

  const GET_SHIP_CRAN_LISTS = async () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);

      const res = await post(ApiURL.list_cargo_machinery_cran_st, FORM_DATA);
      if (res?.status === true) {
        set_CRAN_Data(res?.crane_parameters_data || []);
      }
    } catch (error) {
      console.error("Error BWT list:", error);
    } finally {
      set_loader(false);
    }
  };

  useEffect(() => {
    GET_SHIP_CRAN_LISTS();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {CRAN_Data && CRAN_Data.length > 0 ? (
              <>
                {CRAN_Data?.map((_items) => (
                  <CargoCran
                    key={_items.id} // add key for performance
                    eng_log_basic_id={eng_log_basic_id}
                    _items={_items}
                  />
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};
